import { MapPin, Users, Hand } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const STEPS = [
    {
        number: "01",
        icon: MapPin,
        title: "Open Lunar",
        copy: "Check in wherever you’re already spending time.",
    },
    {
        number: "02",
        icon: Users,
        title: "See who’s around",
        copy: "Explore people and groups who are open to meeting, or let Lunar help find people you might genuinely get on with.",
    },
    {
        number: "03",
        icon: Hand,
        title: "Wave",
        copy: "See someone you’d like to meet? Send a Wave. If they Wave too, go and say hello.",
    },
];

export const HowItWorks = () => (
    <section id="how-it-works" className="mx-auto max-w-6xl scroll-mt-8 px-6 py-24 sm:py-32" data-testid="how-it-works-section">
        <Reveal>
            <Chapter index="01" label="How it works" />
            <h2
                data-testid="how-it-works-heading"
                className="font-display mt-5 max-w-xl text-4xl font-medium leading-[1.1] tracking-tight text-[#1D201A] sm:text-5xl"
            >
                You’re already in the same place.
            </h2>
        </Reveal>
        <div className="mt-16 grid gap-12 sm:mt-20 md:grid-cols-3 md:gap-8">
            {STEPS.map(({ number, icon: Icon, title, copy }, i) => (
                <Reveal key={number} delay={i * 0.12} data-testid={`how-it-works-step-${i + 1}`}>
                    <div className="border-t border-[#C2C0B8] pt-7">
                        <div className="flex items-center justify-between">
                            <span className="font-display text-5xl font-medium leading-none text-[#899B6A]">
                                {number}
                            </span>
                            <Icon className="h-6 w-6 text-[#4A5D23]" strokeWidth={1.5} />
                        </div>
                        <h3 className="font-display mt-5 text-2xl font-semibold text-[#1D201A]">
                            {title}
                        </h3>
                        <p className="mt-2 max-w-xs text-base leading-relaxed text-[#5C5F58]">
                            {copy}
                        </p>
                    </div>
                </Reveal>
            ))}
        </div>
        <Reveal delay={0.15}>
            <p
                data-testid="how-it-works-lunar-spots"
                className="mt-16 text-center text-base text-[#5C5F58] sm:text-lg"
            >
                And if Lunar spots someone particularly worth meeting, she’ll let you know. 🌿
            </p>
        </Reveal>
        <Reveal delay={0.2}>
            <p
                data-testid="how-it-works-message-limit"
                className="font-display mt-16 text-center text-2xl font-medium italic text-[#4A5D23] sm:text-3xl"
            >
                <span className="text-[1.35em]">10</span> messages max. Lunar is made for meeting.
            </p>
        </Reveal>
    </section>
);
